import Vue from 'vue'

export default {
  getHospitalRecords (callback) {
    Vue.http.get('/static/data/hospital-data.json').then(
      (response) => { callback(response.body) }
    )
  },

  getOpos (callback) {
    Vue.http.get('/static/data/opos.geojson').then(
      (response) => { callback(response.body) }
    )
  },

  getStates (callback) {
    Vue.http.get('/static/data/states.geojson').then(
      (response) => { callback(response.body) }
    )
  },

  getTxCenters (callback) {
    Vue.http.get('/static/data/tx-centers.json').then(
      (response) => {
        var txCenters = []
        var data = response.body
        for (var i = 0; i < data.length; i++) {
          if (!data[i].unos_id) {
            continue
          }
          txCenters.push({
            tx_ctr_id: data[i].id,
            tx_ctr_zip: data[i].tx_ctr_zip,
            latLng: { lat: data[i].lat, lng: data[i].lng },
            name: data[i].name,
            unos_id: data[i].unos_id,
            opo_id: data[i].opo_id,
            image: data[i].image,
            description: data[i].description
          })
        }
        callback(txCenters)
      }
    )
  },

  getTxRecords (callback) {
    Vue.http.get('/static/data/txc-data.json').then(
      (response) => { callback(response.body) }
    )
  },

  getUnos (callback) {
    Vue.http.get('/static/data/unos.geojson').then(
      (response) => { callback(response.body) }
    )
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js